export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8144.a6bd209a.jpg";